import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { getCompanyName } from "constants/constAPI";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);
  const [username, setusername] = useState("Admin");
  const [firmName, setFirmName] = useState(getCompanyName());

  useEffect(() => {
    const updateUserData = () => {
      try {
        setFirmName(getCompanyName());
        if (localStorage.getItem("authUser")) {
          const obj = JSON.parse(localStorage.getItem("authUser"));
          setusername(obj.username || obj.displayName || obj.UserName || "Admin");
        }
      } catch (e) {}
    };

    updateUserData();

    // Listen for custom firmProfileUpdate event
    window.addEventListener("firmProfileUpdated", updateUserData);
    return () => {
      window.removeEventListener("firmProfileUpdated", updateUserData);
    };
  }, [props.success]);

  const initialLetter = (firmName || username || "U").trim().charAt(0).toUpperCase();

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item d-flex align-items-center px-2"
          id="page-header-user-dropdown"
          tag="button"
          style={{ gap: "6px" }}
        >
          <div
            className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
            style={{
              width: "32px",
              height: "32px",
              background: "linear-gradient(135deg, #556ee6 0%, #3b50c4 100%)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              flexShrink: 0
            }}
          >
            {initialLetter}
          </div>
          <div className="text-start d-none d-md-inline-block" style={{ maxWidth: "150px" }}>
            <div className="fw-semibold text-truncate text-dark font-size-13" style={{ lineHeight: "1.2" }}>
              {firmName}
            </div>
            <div className="text-muted font-size-11" style={{ lineHeight: "1" }}>
              {username}
            </div>
          </div>
          <i className="mdi mdi-chevron-down d-none d-sm-inline-block text-muted ms-1" />
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end shadow-lg border-0" style={{ minWidth: "240px", borderRadius: "12px", padding: "8px 0" }}>
          <div className="px-3 py-2 bg-light border-bottom mb-1">
            <span className="text-muted font-size-11 text-uppercase fw-semibold">Signed in firm</span>
            <div className="fw-bold text-dark font-size-13 text-truncate">{firmName}</div>
            <div className="text-muted font-size-11 text-truncate">User: {username}</div>
          </div>

          <Link to="/profile" className="dropdown-item d-flex align-items-center py-2" onClick={() => setMenu(false)}>
            <i className="bx bx-buildings font-size-18 text-primary me-2" />
            <div>
              <div className="fw-semibold font-size-13">Firm Profile & Details</div>
              <small className="text-muted font-size-11">View & update company info</small>
            </div>
          </Link>

          <Link to="/profile?tab=subscription" className="dropdown-item d-flex align-items-center py-2" onClick={() => setMenu(false)}>
            <i className="bx bx-crown font-size-18 text-warning me-2" />
            <div>
              <div className="fw-semibold font-size-13">Subscription Plan</div>
              <small className="text-muted font-size-11">Validity & helpline</small>
            </div>
          </Link>

          <div className="dropdown-divider my-1" />

          <Link to="/logout" className="dropdown-item text-danger d-flex align-items-center py-2" onClick={() => setMenu(false)}>
            <i className="bx bx-power-off font-size-16 me-2" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile || {};
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
